import { createFileRoute } from '@tanstack/react-router'

import { MailSettingsPage } from '#/modules/thecargo-mail/settings-page'

export const Route = createFileRoute('/_shell/mail-settings')({
  component: MailSettingsPage,
})
